import { ref } from 'vue';
import { session } from './session';

const isLocalhostDesktop = (
    import.meta.env.VITE_APP_IS_MOBILE !== 'true'
    && typeof window !== 'undefined'
    && window.location.hostname === 'localhost'
);

const canSeeDebug = Boolean(session.account?.is_staff) || isLocalhostDesktop;

export const showDebug = ref(false);

if (canSeeDebug && typeof window !== 'undefined') {
    const isTypingTarget = (target: EventTarget | null) => {
        if (!target) return false;
        const el = target as HTMLElement;
        return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable;
    };
    window.addEventListener('keydown', (e) => {
        if (e.key !== 'd' && e.key !== 'D') return;
        if (isTypingTarget(e.target)) return;
        showDebug.value = !showDebug.value;
    });
}
